module.exports = __webpack_public_path__ + "media/images/icons/plus-white-91abeff78d96f684b6909a2b4ca38f74.svg";